export default "__VITE_ASSET__f7ef4a34__"